import { render, staticRenderFns } from "./footer_nav.vue?vue&type=template&id=3079a178&scoped=true&"
import script from "./footer_nav.vue?vue&type=script&lang=js&"
export * from "./footer_nav.vue?vue&type=script&lang=js&"
import style0 from "./footer_nav.vue?vue&type=style&index=0&id=3079a178&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3079a178",
  null
  
)

export default component.exports